// extracted by mini-css-extract-plugin
module.exports = {"secureBrowserImg":"security_secureBrowserImg__NSOuJ"};